<template lang="html">
  <div>
    <div class="photo_header_top">
      <van-nav-bar
        title="产品图集"
        left-arrow
        fixed
        @click-left="onClickLeft"/>
    </div>
    <div class="photo_content">
      <div class="p_cat" >
        <div class="p_cat_name">
        <router-link tag='li' :to="`/photo/0`">
          <span>产品图集</span>
        </router-link>
          <router-link tag='li' v-show="i.catid" v-for="(i,index) in navlist" :key="index" :to="`/photo/${i.catid}`">
             &nbsp;>&nbsp;<span>{{i.catname}}</span>
        </router-link>
        </div>
        
        <router-link tag='li' v-for="(i,index) in catlist" :key="index" :to="`/photo/${i.catid}`">
            <span>{{i.catname}}</span>
        </router-link>
      </div>
      <div class="list">
        <a v-for="(i,index) in data" :key="index">
        <router-link class="maximg" v-if="index%5 == 0" :to="`/photodetail/${i.albumid}`">
          <img :src="i.thumb_img?i.thumb_img:i.pic" alt="">
          <div class="util">
            <span>{{i.albumname}}</span>
            <div class="right_box">
              <b><i>&#xe621;</i><em>{{i.commentnum}}</em></b>
            </div>
          </div>
        </router-link>
        <router-link class="minimg" v-if="index%5 != 0" :to="`/photodetail/${i.albumid}`">
          <img :src="i.thumb_img?i.thumb_img:i.pic" alt="">
          <div class="util">
            <span>{{i.albumname}}</span>
              <div class="right_box">
                <b><i>&#xe621;</i><em>{{i.commentnum}}</em></b>
              </div>
            </div>
          </router-link>
        </a>
      </div>
      <span class="loadMore" @click="getPhotoMoreData">{{loadMoreTxt}}</span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import utilAxios from '@/utils/axios'
export default {
  data() {
    return{
      data: [],
      listPage:1,
      catlist:[],
      navlist:[],
      loadMoreTxt: '点击加载更多',
    }
  },
  created() {
    this.getPhotoData()
  },
  watch:{
    '$route' : 'getPhotoData'
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    
    getPhotoData() {
      utilAxios.get({
        url: '/new_api.php?module=album&act=list&catid='+this.$route.params.catid,
        method: 'GET',
        callback: (res) => {
          this.catlist=res.data.catlist
          this.navlist=res.data.navlist
          this.data = []
          if(res.data.code == 100) {
            this.data = res.data.data
            console.log(this.data);
          }else{
            this.loadMoreTxt='没有更多了';
          }
        }
      })
    },
    getPhotoMoreData() {
      this.listPage+=1;
      utilAxios.get({
        url: '/new_api.php?module=album&act=list&catid='+this.$route.params.catid+'&page='+this.listPage,
        method: 'GET',
        callback: (res) => {
          if(res.data.code == 100) {
            this.data = res.data.data
            for(let i in res.data.data){
              this.data.push(res.data.data[i])
            }
          }else{
            this.loadMoreTxt='没有更多了';
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.photo_content{
  .loadMore{
    display: block;
    width: 100%;
    height: .4rem;
    text-align: center;
    line-height: .4rem;
  }
  margin-top: .46rem;
  .p_cat{
    padding:.1rem;
    background:#fff;
    overflow:hidden;
    .p_cat_name{
      float:left;
      line-height:.3rem;
      font-size:.14rem;
      margin-right:.1rem;
      color:#000;
      li{
        margin-right:0;
      }
    }
    li{
      float:left;
      line-height:.3rem;
      list-style:none;
      margin-right:.1rem;
    }
    
  }
  .list{
    padding: .1rem;
    background: #fff;
    .maximg{
      img{
        width: 100%;
      }
      .util{
        display: flex;
        width: 100%;
        height: .3rem;
        line-height: .3rem;
        span{
          flex: 3;
          color: #222;
        }
        .right_box{
          flex: 2;
          display: flex;
          justify-content: flex-end;
          color: #222;
          b{
            padding: 0 .05rem;
            i{
              padding: 0 .04rem;
            }
          }
        }
      }
    }
    .minimg{
      width: 49%;
      display: inline-block;
      img{
        width: 100%;
        height: auto;
      }
      .util{
        display: flex;
        width: 100%;
        height: .3rem;
        line-height: .3rem;
        span{
          flex: 3;
          color: #222;
        }
        .right_box{
          flex: 2;
          display: flex;
          justify-content: flex-end;
          color: #222;
          b{
            padding: 0 .05rem;
            i{
              padding: 0 .04rem;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Photo/Photo.vue